import React from 'react'

type TypeImportFunction<T> = () => Promise<{
  default: React.ComponentType<T>
}>

type TypeLazyComponent<T> = React.LazyExoticComponent<React.ComponentType<T>> & {
  preload: TypeImportFunction<T>
}

const lazyWithPreload = <T>(importFunction: TypeImportFunction<T>) => {
  const Component = React.lazy(importFunction) as TypeLazyComponent<T>
  Component.preload = importFunction
  return Component
}

export { lazyWithPreload }
